import { FormattedDateTime, Icon } from '@elotech/components';
import React from 'react';

const OffSidebarVersionInfo = ({
  offsidebarUsuarioSobreVersao,
  info,
  onClickNovidadesVersao
}) => {
  return (
    <>
      <h2 className="title">
        <div
          className="read hint clean center-left neutral"
          onClick={offsidebarUsuarioSobreVersao}
        >
          <Icon icon="chevron-left" />
          <div className="hint-content">Voltar</div>
        </div>
        Sobre o sistema
      </h2>
      <ul className="user-actions">
        <div className="col-md-12 form-group mb-xs">
          {info && (
            <article>
              <label>Versão</label>
              <p>
                {info.getIn(['build', 'version'])
                  ? info.getIn(['build', 'version'])
                  : 'Carregando...'}
              </p>
              <label>Data</label>
              <p>
                {info.getIn(['build', 'time']) ? (
                  <FormattedDateTime value={info.getIn(['build', 'time'])} />
                ) : (
                  'Carregando...'
                )}
              </p>
            </article>
          )}
        </div>
        <li className="form-group" onClick={onClickNovidadesVersao}>
          <Icon icon="info-circle" className="icon" />
          Confira as novidades da versão
        </li>
      </ul>
    </>
  );
};

export default OffSidebarVersionInfo;
